import { render, staticRenderFns } from "./OptionaleGruppe.vue?vue&type=template&id=97654c98&scoped=true&"
import script from "./OptionaleGruppe.vue?vue&type=script&lang=js&"
export * from "./OptionaleGruppe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97654c98",
  null
  
)

export default component.exports